import React from 'react';
import { Instagram, Mail, Phone, MapPin } from 'lucide-react';
import { content } from '../data/content';
import logo from "../assets/logo-foody.PNG";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-neutral-950 border-t border-amber-200/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid md:grid-cols-3 gap-12 mb-8">
          {/* Brand */}
          <div>
            <div className="flex items-center space-x-3 mb-4">
              <img
              src={logo}
              alt="Foody Burger 49"
              className="h-20 w-auto transition-transform duration-200 group-hover:scale-105"
              />
            </div>
            <p className="text-amber-100/70 text-sm leading-relaxed">
              Una piattaforma di brand experience su ruote. Ford F68 del 1949 trasformato in cucina professionale 100% gluten free.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-amber-50 font-bold text-lg mb-4">Link rapidi</h3>
            <ul className="space-y-2">
              <li>
                <button
                  onClick={() => document.getElementById('about')?.scrollIntoView({ behavior: 'smooth' })}
                  className="text-amber-100/70 hover:text-amber-50 transition-colors text-sm"
                >
                  Storia
                </button>
              </li>
              <li>
                <button
                  onClick={() => document.getElementById('services')?.scrollIntoView({ behavior: 'smooth' })}
                  className="text-amber-100/70 hover:text-amber-50 transition-colors text-sm"
                >
                  Servizi
                </button>
              </li>
              <li>
                <button
                  onClick={() => document.getElementById('menu')?.scrollIntoView({ behavior: 'smooth' })}
                  className="text-amber-100/70 hover:text-amber-50 transition-colors text-sm"
                >
                  Menu
                </button>
              </li>
              <li>
                <button
                  onClick={() => document.getElementById('gallery')?.scrollIntoView({ behavior: 'smooth' })}
                  className="text-amber-100/70 hover:text-amber-50 transition-colors text-sm"
                >
                  Gallery
                </button>
              </li>
              <li>
                <button
                  onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}
                  className="text-amber-100/70 hover:text-amber-50 transition-colors text-sm"
                >
                  Contatti
                </button>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-amber-50 font-bold text-lg mb-4">Contatti</h3>
            <ul className="space-y-3">
              <li>
                <a 
                  href={`tel:${content.contact.phone}`}
                  className="flex items-center space-x-3 text-amber-100/70 hover:text-amber-50 transition-colors text-sm"
                >
                  <Phone className="w-4 h-4" />
                  <span>{content.contact.phone}</span>
                </a>
              </li>
              <li>
                <a 
                  href={`mailto:${content.contact.email}`}
                  className="flex items-center space-x-3 text-amber-100/70 hover:text-amber-50 transition-colors text-sm"
                >
                  <Mail className="w-4 h-4" />
                  <span>{content.contact.email}</span>
                </a>
              </li>
              <li>
                <div className="flex items-center space-x-3 text-amber-100/70 text-sm">
                  <MapPin className="w-4 h-4" />
                  <span>{content.contact.location}</span>
                </div>
              </li>
              <li>
                <a 
                  href={`https://instagram.com/${content.contact.instagram.replace('@', '')}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center space-x-3 text-amber-100/70 hover:text-amber-50 transition-colors text-sm"
                >
                  <Instagram className="w-4 h-4" />
                  <span>{content.contact.instagram}</span>
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-amber-200/10 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0 mb-6">
            <p className="text-amber-100/60 text-sm">
              © {currentYear} Foody Burger 49. Tutti i diritti riservati.
            </p>
            <div className="flex items-center space-x-6">
              <a href="#" className="text-amber-100/60 hover:text-amber-50 transition-colors text-sm">
                Privacy Policy
              </a>
              <a href="#" className="text-amber-100/60 hover:text-amber-50 transition-colors text-sm">
                Cookie Policy
              </a>
            </div>
          </div>

          {/* Legal Information */}
          <div className="text-center pt-4 border-t border-amber-200/5">
            <p className="text-amber-100/40 text-xs leading-relaxed">
              Di Rienzo Alessandro – Foody Burger 49<br />
              P.IVA 13302640019 • Sede legale: Alpignano (TO), Italia<br />
              PEC: alessandrodirienzo@arubapec.it
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
